<template>
   <div class="modal fade" 
      id="cellActionOrder" 
      aria-hidden="true" 
      aria-labelledby="cellActionOrderLabel" 
      tabindex="-1"
      >
      <div class="modal-dialog">
         <div class="modal-content bg-light">
            <div class="modal-header ps-0">
               <button 
                  class="btn btn-light btn-small tc-d-gray py-0" 
                  data-bs-target="#cellAction" 
                  data-bs-toggle="modal"
                     :data-cell-id="cellId"
                     :data-cell-name="cellName" 
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                     <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                  </svg>
               </button>
               <div class="w-100 text-center">
                  <h6 class="modal-title" id="cellActionOrderLabel"><b>{{cellName}}</b></h6>
               </div>
               <button 
                  id="bttCloseMdOrder"
                  type="button" 
                  class="btn-close 
                  btn-small" 
                  data-bs-dismiss="modal" 
                  aria-label="Close" 
                  ref="bttCloseMdOrder"
                  >
               </button>
            </div>
            <div class="modal-body">

               <div class="form-check">
                  <input class="form-check-input" type="radio" id="title" value="title" v-model="fieldPicked" />
                  <label for="title">Titulo</label>
               </div>
               <div class="form-check">
                  <input class="form-check-input" type="radio" id="start_date" value="start_date" v-model="fieldPicked" />
                  <label for="start_date">Fecha de Inicio</label>
               </div>
               <div class="form-check">
                  <input class="form-check-input" type="radio" id="end_date" value="end_date" v-model="fieldPicked" />
                  <label for="end_date">Fecha de Vencimiento</label>
               </div>
               <div class="form-check">
                  <input class="form-check-input" type="radio" id="ID" value="ID" v-model="fieldPicked" />
                  <label for="ID">Identificador (ID)</label>
               </div>
               
               <hr class="tc-gray">

               <div class="text-center">
                  <div class="form-check form-check-inline">
                     <input class="form-check-input" type="radio" id="asc" value="asc" v-model="orderPicked" />
                     <label for="asc">Ascendente</label>
                  </div>
                  <div class="form-check form-check-inline">
                     <input class="form-check-input" type="radio" id="desc" value="desc" v-model="orderPicked" />
                     <label for="desc">Descendente</label>
                  </div>
               </div>

            </div>
               <!--
            <hr class="tc-gray">
               <div>Field: {{ fieldPicked }}</div>
               <br/>
               <div>Order: {{ orderPicked }}</div>
               <br/>
               <div>SortParameters: {{ sortParameters }}</div>
               <br/>
               -->
            <div class="d-grid px-3 pb-2">
               <button class="btn btn-primary" :disabled="sorting || !newSort" @click="doSort()" >
                 <span v-show="sorting"  class="spinner-border spinner-border-sm"></span>
                  {{txtBttSort}}
               </button>
            </div>
         </div>
      </div>
   </div>
   <!--
   -->
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue'
import { useStore } from 'vuex'
//import WspService from "../workSpace.service";

//import mdActionOrder from '../components/MdCellActionOrder.vue';

export default {
   components: {
      //mdActionOrder
   },
   setup() {

      const bttCloseMdOrder = ref(null)
      const cellId = ref(0)
      const cellName = ref('Acciones')
      const currentSort = ref('')
      const fieldPicked = ref('')
      const newSort = ref(false)
      const orderPicked = ref('')
      const sorting = ref(false)
      const sortParameters = ref({})
      const txtBttSort = ref('')


      const store = useStore()

      onMounted(() => {
         document.getElementById('cellActionOrder')
         .addEventListener('show.bs.modal', function (event) {
            let button = event.relatedTarget

            cellId.value = button.getAttribute('data-cell-id')
            cellName.value = button.getAttribute('data-cell-name')

            sorting.value = false
            txtBttSort.value = 'Ordenar'
            //fieldPicked.value = 'ID'
            //orderPicked.value = 'desc'
            let sortParamIndex = store.state.wspace.sortParameters.findIndex((obj => obj.cellId === cellId.value));
            if (sortParamIndex >= 0) {
               fieldPicked.value = store.state.wspace.sortParameters[sortParamIndex].field
               orderPicked.value = store.state.wspace.sortParameters[sortParamIndex].order
               currentSort.value = fieldPicked.value + orderPicked.value
            }
            //console.log('sortParamIndex: '+sortParamIndex+","+fieldPicked.value+","+orderPicked.value)
            sortParameters.value = store.state.wspace.sortParameters
         })
         //console.log('mounted the modal')
      })

      watchEffect(() => {
         if ( currentSort.value != fieldPicked.value + orderPicked.value)
            newSort.value = true
         else
            newSort.value = false
      })

      function doSort() {
         store.dispatch("wspace/updateSortParam", {
            cellId: cellId.value,
            field: fieldPicked.value,
            order: orderPicked.value
         })
         sorting.value = true
         txtBttSort.value = 'Ordenando'
         //console.log('order: '+orderPicked.value)
         //bttCloseMdOrder.value.click()
      }

      return {
         bttCloseMdOrder,
         cellId,
         cellName,
         doSort,
         fieldPicked,
         newSort,
         orderPicked,
         sorting,
         sortParameters,
         txtBttSort
      };
   }
}
</script>

<style scoped>
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
</style>